"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const LocationWrapper_vue_1 = __importDefault(require("../components/LocationWrapper.vue"));
const DetailsLocationsContainer_vue_1 = __importDefault(require("../components/DetailsLocationsContainer.vue"));
const LocationCard_vue_1 = __importDefault(require("../components/LocationCard.vue"));
let LocationsGrid = class LocationsGrid extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.deployLocationId = -1;
    }
    updateLocationTime(l) {
        this.$emit('updateLocationTime', l);
    }
    updateAssignatedSamples(payload) {
        this.$emit('updateAssignatedSamples', payload);
    }
    updateSentSamples(payload) {
        this.$emit('updateSentSamples', payload);
    }
    deployPanelDetailsLocation(location) {
        if (this.deployLocationId === location.id) {
            this.deployLocationId = -1;
        }
        else {
            this.deployLocationId = location.id;
        }
    }
    isCardOpenDetails(location) {
        if (this.deployLocationId === location.id) {
            return true;
        }
        else {
            return false;
        }
    }
    get cropName() {
        return this.trialsMeta.collectCropObject.name;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], LocationsGrid.prototype, "locations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], LocationsGrid.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], LocationsGrid.prototype, "trialsMeta", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], LocationsGrid.prototype, "params", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], LocationsGrid.prototype, "elementsForLine", void 0);
LocationsGrid = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            LocationWrapper: LocationWrapper_vue_1.default,
            LocationCard: LocationCard_vue_1.default,
            DetailsLocationsContainer: DetailsLocationsContainer_vue_1.default
        },
    })
], LocationsGrid);
exports.default = LocationsGrid;
